import { Section } from "../../components/Section";
import { Scriptbox } from "../../components/Scriptbox";
// import { useRef } from "react";
export function Streaming({ takeref }: { takeref: any }) {
  // const section11 = useRef(null);
  return (
    <Section heading="Provide Points to Your Customers" takeref={takeref}>
      <p>
        You can interact with the API through HTTP requests from any language,
        via our official Python bindings, our official Node.js library, or a
        community-maintained library.
      </p>
      <p>To interact with the API and provide points to your customers or burn points, you can use a POST request.</p>

      <p><strong>API Endpoint:</strong> <code>POST /v1/provide-points/</code></p>

      <p><strong>Required Headers:</strong></p>
      <ul>
        <li><strong>Authorization:</strong> <code>Api-Key &lt;Your-API-Key&gt;</code></li>
      </ul>

      <p><strong>Request Body:</strong></p>
      <p>The request body should include the following fields:</p>
      <ul>
        <li><strong>points:</strong> The number of points to either earn or burn.</li>
        <li><strong>transactionType:</strong> Either "earn" or "burn" to indicate whether the points are being added or deducted.</li>
        <li><strong>key_type:</strong> The type of API key used (e.g., "business", "partner").</li>
        <li><strong>phone, email, or unique_app_id:</strong> One of these identifiers should be provided to target the specific user.</li>
      </ul>

      <p>
        Example of a valid POST request body:
      </p>
      <Scriptbox
        codedata={[
          '{"phone": "1234567890", "points": 100, "transactionType": "earn", "key_type": "business"}'
        ]}
      ></Scriptbox>

      <p>Example for burning points:</p>
      <Scriptbox
        codedata={[
          '{"phone": "1234567890", "points": 50, "transactionType": "burn", "key_type": "business"}'
        ]}
      ></Scriptbox>

      <p>Response:</p>
      <ul>
        <li>Success: Returns the updated loyalty points balance for the user.</li>
        <li>Failure: If the user does not exist or there are insufficient points for burning, an error message will be returned.</li>
      </ul>

      <p>
        Example of a successful response:
      </p>
      <Scriptbox
        codedata={[
          '{"msg": "John Doe has 150 Loyalty Points"}'
        ]}
      ></Scriptbox>
    </Section>
  );
}